// Import entities.
import Dates 				from './model/entity/Dates.js';
import Strategies			from './model/entity/Strategies.js';
import Targets				from './model/entity/Targets.js';
import Milestone 			from './model/entity/Milestone.js';
import GatedMilestone 		from './model/entity/GatedMilestone.js';
import TemplateOptions 		from './model/entity/TemplateOptions.js';
import Formatting 			from './model/entity/Formatting.js';

// Import business logic.
import StateProcessing 		from './model/logic/State.js';
import ProgressProcessing 	from './model/logic/Progress.js';

/**
 * Goal model entities.
 *
 * @memberof module:Goal.Model
 * @namespace
 */
const Entity = {
	Dates:Dates,
	Strategies:Strategies,
	Targets:Targets,
	Milestone:Milestone,
	GatedMilestone:GatedMilestone,
	TemplateOptions:TemplateOptions,
	Formatting:Formatting
};
export { Entity };

/**
 * Goal model business logic.
 *
 * @memberof module:Goal.Model
 * @namespace
 */
const Logic = {
	StateProcessing:StateProcessing,
	ProgressProcessing:ProgressProcessing
};
export { Logic };

/**
 * Goal model.
 *
 * @author Tim Loram
 *
 * @memberof module:Goal
 * @namespace
 *
 * @type {Object}
 * @property {Object} Entity All model Entities
 * @property {Object} Logic All model Business Logic
 */
const Model = {
	Entity:Entity,
	Logic:Logic
};

export default Model;